import { Language, ReleaseNotesObject } from '../entities/models/firmware-stepper.model';
import {
  BackendFirmwarePackageDetailsDto,
  VersionNumber
} from '../infrastructure/types/firmware-upload.types';

export const formatAccess = (access: string) => {
  switch (access.toLowerCase()) {
    case 'cpoanduser':
      return 'Update by CPO & end-user';
    case 'cpo':
      return 'Update by CPO';
    default:
      return access;
  }
};

export function formatCompatibleVersions(versions: VersionNumber[]): string[] {
  return versions.map(
    version =>
      `${version.cpNumber}-${version.hardwareId},${version.major}.${version.minor}.${version.develop}`
  );
}

export function mapBackendFirmwarePackageDataToFrontendFirmwareData(
  input: BackendFirmwarePackageDetailsDto
) {
  const formatClassification = (classification: string) => {
    switch (classification.toLowerCase()) {
      case 'minor':
        return 'Minor update';
      case 'major':
        return 'Major update';
      case 'critical':
        return 'Critical update';
      default:
        return classification;
    }
  };

  function mapReleaseNotesArrayToObject(releaseNotesArray: Language[]): ReleaseNotesObject {
    return {
      notes: releaseNotesArray.reduce<{ [key: string]: string }>((acc, cur) => {
        acc[cur.languageCode] = cur.text;
        return acc;
      }, {})
    };
  }

  return {
    packageMetadata: {
      classification: formatClassification(input.packageMetadata.classification),
      packageName: input.packageMetadata.packageName
    },
    distribution: {
      access: formatAccess(input.distribution.access),
      supportedCompanionApps: input.distribution.supportedCompanionApps
    },

    deviceCompatibility: {
      compatible_device_software_versions: formatCompatibleVersions(input.compatibleVersions)
    },
    fileUpload: {
      fileName: input.fileInfo.fileName,
      fileSize: input.fileInfo.fileSizeInBytes
    },
    manifestInfo: {
      manifest: input.manifest
    },
    releaseNotes: mapReleaseNotesArrayToObject(input.releaseNotes),
    packageStatus: input.packageStatus
  };
}
